import { render, staticRenderFns } from "./ListAnime.vue?vue&type=template&id=5a624adc&"
import script from "./ListAnime.vue?vue&type=script&lang=js&"
export * from "./ListAnime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports